module.exports = __webpack_public_path__ + "img/parallax-item-1-563x532.c48ca5a9.png";